var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.33332H20V0.666656H17.3333V3.33332H6.66667V0.666656H4V3.33332H2.66667C1.18667 3.33332 0.0133333 4.53332 0.0133333 5.99999L0 24.6667C0 25.3739 0.280951 26.0522 0.781048 26.5523C1.28115 27.0524 1.95942 27.3333 2.66667 27.3333H21.3333C22.8 27.3333 24 26.1333 24 24.6667V5.99999C24 4.53332 22.8 3.33332 21.3333 3.33332ZM21.3333 24.6667H2.66667V11.3333H21.3333V24.6667ZM8 16.6667H5.33333V14H8V16.6667ZM13.3333 16.6667H10.6667V14H13.3333V16.6667ZM18.6667 16.6667H16V14H18.6667V16.6667ZM8 22H5.33333V19.3333H8V22ZM13.3333 22H10.6667V19.3333H13.3333V22ZM18.6667 22H16V19.3333H18.6667V22Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.080c75d6bf5c203ab71577a3a95b391b.svg";
export { ForwardRef as ReactComponent };